import { useEffect, useState } from 'react';
import { useLoaderData, useNavigate, useParams, useRevalidator } from 'react-router';
import { removeModel } from '@/api/registry';

const AspenModelProcessingTable = () => {
  const { customModels } = useLoaderData();
  const navigate = useNavigate();
  const { pathwayId, projectId, caseId } = useParams();
  const { revalidate } = useRevalidator();
  const [deletingIds, setDeletingIds] = useState(new Set());
  const hasParsingModels = customModels?.some(model => model.status === 'parsing');

  // Auto-refresh every 30 seconds if there are models with "parsing" status
  useEffect(() => {
    if (!hasParsingModels) {
      return;
    }

    const interval = setInterval(() => {
      revalidate();
    }, 30000);

    return () => {
      return clearInterval(interval);
    };
  }, [hasParsingModels, revalidate]);

  if (!customModels.length) {
    return null;
  }

  const handleContinueBuild = model => {
    navigate(`/projects/${projectId}/build/pathways/${pathwayId}/${caseId}/choose-model/import-from-aspen`, {
      state: { model },
    });
  };

  const handleDelete = async id => {
    setDeletingIds(prev => new Set(prev).add(id));
    try {
      await removeModel(id);
      revalidate();
    } finally {
      setDeletingIds(prev => {
        const next = new Set(prev);
        next.delete(id);
        return next;
      });
    }
  };

  return (
    <div className="mt-8">
      <h4 className="font-medium mb-4">Aspen Model Processing</h4>
      <div className="overflow-auto border border-gray-200 rounded-lg">
        <table className="table table-zebra w-full">
          <thead className="sticky top-0 bg-base-100 z-10">
            <tr>
              <th>Id</th>
              <th>Status</th>
              <th className="text-center"></th>
              <th className="text-center"></th>
            </tr>
          </thead>
          <tbody>
            {customModels.map(model => (
              <tr key={model.id}>
                <td>{model?.data?.label}</td>
                <td>{model.status}</td>
                <td className="text-center">
                  {model.status === 'pending' && (
                    <button className="btn btn-xs btn-accent" onClick={() => handleContinueBuild(model)}>
                      Continue Build
                    </button>
                  )}
                </td>
                <td className="text-center">
                  <button
                    className="btn btn-xs btn-error"
                    onClick={() => handleDelete(model.id)}
                    disabled={deletingIds.has(model.id)}
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AspenModelProcessingTable;
